import React from 'react';
import { TreePine } from 'lucide-react';
import Logo from './Logo';

interface LoadingProps {
  message?: string;
  priority?: boolean;
}

export default function Loading({ message = 'Cargando...', priority = false }: LoadingProps) {
  return (
    <div className="fixed inset-0 bg-primary flex flex-col items-center justify-center z-50 transition-opacity duration-300">
      <div className="text-center">
        <div className="mb-8">
          <Logo priority={priority} />
        </div>
        <div className="relative">
          <TreePine className="h-16 w-16 text-secondary animate-bounce" />
          <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-8 h-1 bg-secondary/20 rounded-full animate-pulse"></div>
        </div>
        <div className="mt-8 flex flex-col items-center">
          <div className="h-1 w-32 bg-white/10 rounded-full overflow-hidden">
            <div className="h-full w-1/2 bg-secondary rounded-full animate-[loading_1s_ease-in-out_infinite]"></div>
          </div>
          <p className="text-white/80 mt-4 text-sm font-light">{message}</p>
        </div>
      </div>
    </div>
  );
}